import React from 'react';
import numeral from 'numeral';

import { idWithTenant, } from '../shared/util';
import { smallImageUrl, } from '../shared/models/amazonProduct';
import ProductTagsDisplay from './ProductTagsDisplay';

export default function ProductSelectOptionLabel (props) {
  const { product, admin = false, goodInventoryWithoutAllocation, waitingToShippingGoodCount, ...extraProps } = props;
  const { ref, sku, code, asin, name, isAmazonProduct, isCase, isSet, amazonProduct, } = product;

  return (
    <div {...extraProps}>
      <div className="d-flex gap-1 flex-wrap align-items-center">
        {isCase && <span className="small badge badge-info">ケース</span>}
        {isSet && <span className="small badge badge-warning">セット</span>}
        {admin && <span className="small badge badge-secondary">ID: {idWithTenant(ref)}</span>}
        <span className="small badge badge-secondary">SKU: {sku}</span>
        <span className="small badge badge-secondary">CD: {code}</span>
        {isAmazonProduct && <span className="small badge badge-secondary">ASIN: {asin}</span>}
        <ProductTagsDisplay product={product} productTags={[]} />
        {goodInventoryWithoutAllocation != null && <span className="small badge badge-secondary">フリー: {numeral(goodInventoryWithoutAllocation).format()}</span>}
        {waitingToShippingGoodCount != null && <span className="small badge badge-secondary">引当済み: {numeral(waitingToShippingGoodCount).format()}</span>}
      </div>
      <div className="d-flex align-items-start gap-1">
        {
          isAmazonProduct && (
            <div>
              <img src={smallImageUrl(amazonProduct)} style={{ maxHeight: 40 }} />
            </div>
          )
        }
        <div className="flex-grow-1 text-wrap">
          <span>{name}</span>
        </div>
      </div>
    </div>
  );
};
